// Modelos de la configuración de permisos de Censo (P1.3-104). Reflejan la API /permisos/*.
// El frontend NUNCA decide autorización: solo muestra u oculta opciones. Cada petición la valida el servidor.

export type NivelPermiso = 'consulta' | 'escritura' | 'administracion';
export type AlcancePermiso = 'global' | 'asociacion';

export interface PermisoCatalogo {
  codigo: string;
  modulo: string;
  nivel: NivelPermiso;
  alcances: AlcancePermiso[];
  sensible: boolean;
  descripcion: string;
  consecuencia: string;
}

export interface ConcesionPermiso {
  codigo: string;
  alcance: AlcancePermiso;
}

export interface CargoPermisos {
  id: number;
  nombre: string;
  esInfantil: boolean;
  permisos: ConcesionPermiso[];
  titularesInstitucionales: number;
  ultimoCambio: { fecha: string; responsableId: number | null; responsable: string | null } | null;
}

export interface AsociacionInstitucional {
  id: number;
  nombre: string | null;
  tipoAsociacion: number | null;
  creadoEn: string;
}

export interface EntradaAuditoria {
  id: number;
  fecha: string;
  actorTipo: string;
  actorId: number | null;
  actorNombre: string | null;
  accion: string;
  recurso: string;
  detalle: string | null;
  resultado: string;
}

export interface ContextoPermisos {
  tipo: 'persona' | 'asociacion' | 'temp' | 'invalid';
  id: number | null;
  activo: boolean;
  global: string[];
  porAsociacion: { asociacionId: number; permisos: string[] }[];
  puedeGestionarPermisos?: boolean;
  /** ¿El estado «desactivada» de una asociación bloquea hoy su acceso en este entorno? */
  bloqueoAsociacionesActivo?: boolean;
}

export const ETIQUETA_NIVEL: Record<NivelPermiso, string> = {
  consulta: 'Consulta',
  escritura: 'Gestión',
  administracion: 'Administración'
};
